import {TableIcon} from '@primer/octicons-react'
import {Box, Link, Octicon} from '@primer/react'

type ProjectV2Props = {
  url: string
  title: string
}

export function ProjectV2({url, title}: ProjectV2Props): JSX.Element {
  return (
    <Box>
      <Octicon icon={TableIcon} />{' '}
      <Link href={url} sx={{color: 'fg.default'}}>
        {title}
      </Link>
    </Box>
  )
}

try{ ProjectV2.displayName ||= 'ProjectV2' } catch {}